<template>
  <DashboardLayout>
    <Breadcrumb class="flex breadcrumb" :model="items" />
    <div class="card flex flex-column pt-4 px-4">
      <div class="flex justify-content-between align-items-center mb-3">
        <span class="Subtitle-Medium">Pending Students</span>
      </div>

      <DataTable :value="pending" :paginator="true" :rows="10" :loading="loading" stripedRows>
        <Column field="username" header="Username" />
        <Column field="email" header="Email" />
        <Column header="Action">
          <template #body="{ data }">
            <Button label="Delete" class="yellow-button-small" @click="deleteInvite(data)" />
          </template>
        </Column>
      </DataTable>
    </div>
  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Breadcrumb from "primevue/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { getpendingStudents, deletePendingStudent } from "@/api/institutes";

const items = [{ label: "Dashboard" }, { label: "Our Students" }, { label: "Pending Invitations" }];
const pending = ref([]);
const loading = ref(false);

const fetchPending = async (page = 1, limit = 10) => {
  loading.value = true;
  try {
    const res = await getpendingStudents({ page, limit, searchTerm: "" });
    pending.value = res.data.data?.students || [];
  } finally {
    loading.value = false;
  }
};

const deleteInvite = async (student) => {
  try {
    await deletePendingStudent(student._id);
    pending.value = pending.value.filter((s) => s._id !== student._id);
  } catch (error) {
    console.error("Error deleting pending student:", error);
  }
};

onMounted(() => fetchPending());
</script>